import React from 'react';
import './MobilePage.css';

const redpayLogo = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="149"
		height="34"
		fill="none"
		viewBox="0 0 149 34"
		className="img"
	>
		<path
			fill="var(--primary-base-color)"
			d="M43.329 12.387c.017.022.05.088.102.13 2.503 2.042 2.966 4.957 1.122 7.615-1.561 2.249-3.74 3.439-6.509 3.41-1.893-.02-3.785-.078-5.676-.162-.7-.03-1.27.106-1.836.561-1.05.847-2.29 1.325-3.777 1.622.114-.373.177-.656.286-.92 1.035-2.488 2.08-4.973 3.116-7.463.142-.34.248-.696.37-1.045l-.204-.127c-.16.186-.35.354-.477.56-.77 1.255-1.508 2.526-2.29 3.773-.5.8-1.027 1.589-1.592 2.345-2.18 2.915-5.146 4.457-8.717 4.915-.417.053-.833.106-1.251.146-.099.01-.203-.034-.465-.083 1.924-2.915 3.885-5.711 5.804-8.536 1.896-2.79 3.796-5.579 5.695-8.368-.074-.06-.148-.121-.223-.18-.239.267-.491.524-.715.805-1.767 2.222-3.514 4.458-5.296 6.668-2.092 2.595-4.302 5.082-6.89 7.206-2.412 1.98-5.049 3.53-8.136 4.204-1.8.393-4.329.352-5.762-.103.064-.47.477-.662.774-.91 1.697-1.412 3.422-2.79 5.121-4.2 6.78-5.616 13.313-11.502 19.286-17.984a98.891 98.891 0 003.264-3.707c.454-.545.97-.75 1.646-.725 3.5.141 7.001.264 10.501.417.66.028 1.333.097 1.967.266 3.816 1.02 5.051 4.948 2.52 7.998-.533.644-1.144 1.222-1.76 1.871l.002.001zm-11.012 7.875c.255.089.383.17.511.174 1.501.033 3.003.082 4.503.07 1.054-.009 1.855-.565 2.468-1.384.56-.749.822-1.606.833-2.545.014-1.375-.822-2.526-2.167-2.651-1.627-.152-3.271-.118-5.054-.168l-1.095 6.503zm1.658-9.581c1.661.047 3.234.222 4.782.097 1.51-.121 2.643-1.882 2.506-3.516-.118-1.414-1.024-2.118-2.823-2.175-.91-.028-1.82-.045-2.73-.04-.74.005-.838.094-.967.814a178.441 178.441 0 00-.526 3.101c-.088.54-.154 1.084-.242 1.719zM64.798 8.04L62.303 22.8l-4.682-.131.47-2.843c-1.334 2.042-3.025 3.048-5.047 2.991-2.798-.079-6.316-2.146-5.38-7.803.938-5.767 5.286-7.585 8.167-7.503 1.69.047 3 .749 3.99 2.08l.296-1.682 4.681.131zm-6.11 8.255l.596-3.45c-.67-1.765-1.587-2.678-2.723-2.71-.97-.027-1.841.42-2.644 1.367-.775.92-1.309 2.152-1.546 3.67-.233 1.408-.183 2.601.177 3.582.388.98 1.012 1.47 1.926 1.496 1.412.04 2.808-1.28 4.215-3.956zM81.433 13.886l-1.596 9.409-4.681-.132 1.563-9.243c.152-1.465.23-3.237-1.32-3.28-1.386-.04-2.783 1.335-4.164 4.095l-1.397 8.278-4.682-.132L67.651 8.12l4.682.132-.467 2.787c1.36-2.013 3.078-2.99 5.155-2.932 3.24.091 4.95 2.44 4.411 5.78zM93.332 14.638l4.26 9.157-5.291-.15-2.433-6.139-1.704 1.449-.766 4.552-4.708-.133 3.556-20.967 4.682.131-2.097 12.444 7.212-6.062 3.767.106-6.478 5.612zM115.588 18.675c-.295 1.6-1.079 2.908-2.357 3.953-1.277 1.045-2.815 1.53-4.559 1.48l-8.975-.253 3.355-19.7 8.116.23c3.74.105 5.731 2.24 5.2 5.33-.3 1.765-1.308 3.123-3.053 4.045 1.75.852 2.642 2.68 2.273 4.915zm-3.019-.085c.557-3.034-1.61-3.843-2.802-3.877l-5.484-.154-1.295 7.56 5.513.155c1.163.032 3.596-.704 4.068-3.683v-.001zm-7.985-5.852l5.097.143c1.136.032 3.23-.49 3.696-3.25.468-2.814-1.429-3.395-2.62-3.428l-5.042-.143-1.13 6.678h-.001zM119.168 22.49c-1.205-1.503-1.597-3.344-1.23-5.552.366-2.18 1.387-3.98 3.064-5.402 1.703-1.421 3.634-2.087 5.795-2.026 2.161.06 3.83.828 5.007 2.33 1.205 1.504 1.597 3.344 1.231 5.524-.368 2.207-1.388 4.008-3.064 5.43-1.676 1.422-3.608 2.088-5.769 2.027-2.16-.06-3.83-.828-5.035-2.331h.001zm8.873-1.053c1.086-1.162 1.762-2.53 2.058-4.156.266-1.6.056-2.993-.659-4.176-.686-1.212-1.668-1.821-2.942-1.857-1.274-.036-2.454.512-3.54 1.674-1.085 1.134-1.761 2.5-2.056 4.1-.268 1.628-.058 3.02.629 4.231.716 1.185 1.696 1.794 2.97 1.83 1.274.036 2.454-.512 3.54-1.646zM138.734 17.746l-4.078-7.739 3.546.1 2.896 5.432 5.082-5.207 2.216.063-6.505 6.553 4.177 8.212-3.518-.099-2.994-5.878-5.371 5.643-2.188-.062 6.741-7.018h-.004z"
		></path>
	</svg>
);

const mobileImg = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="340"
		height="177"
		fill="none"
		viewBox="0 0 340 177"
		className="img"
	>
		<path
			fill="var(--primary-accent-color-two)"
			stroke="var(--primary-accent-color-two)"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="6.407"
			d="M310.217 22.826H192.751c-8.109 0-14.683 6.574-14.683 14.683v73.416c0 8.11 6.574 14.683 14.683 14.683h117.466c8.109 0 14.683-6.573 14.683-14.683V37.509c0-8.11-6.574-14.683-14.683-14.683z"
		></path>
		<path
			stroke="var(--primary-accent-color-two)"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="6.407"
			d="M222.118 154.975h58.733M251.484 125.608v29.367"
		></path>
		<path
			fill="var(--primary-accent-color-two)"
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.602"
			d="M133 15H78c-6.075 0-11 6.581-11 14.7v117.6c0 8.119 4.925 14.7 11 14.7h55c6.075 0 11-6.581 11-14.7V29.7c0-8.119-4.925-14.7-11-14.7z"
		></path>
		<path
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.602"
			d="M88.1 132.149h.074"
		></path>
		<path
			fill="color(display-p3 0.0078 0.4770 0.9338)"
			d="M149.769 66.475l.31.739-.31-.739zm47.675.681a.8.8 0 00.26-1.102l-3.79-6.131a.802.802 0 00-1.363.842l3.369 5.45-5.449 3.37a.801.801 0 10.842 1.362l6.131-3.79zm-68.498 13.735l.537.594h.001l.001-.001a133.894 133.894 0 016.94-5.732c4.056-3.12 9.194-6.67 13.654-8.538l-.619-1.478c-4.662 1.954-9.936 5.613-14.011 8.746a134.95 134.95 0 00-5.051 4.084 109.424 109.424 0 00-1.954 1.7l-.026.023-.007.006-.002.002.537.594zm21.133-13.677c8.315-3.485 19.956-3.506 29.626-2.616 4.815.443 9.102 1.108 12.186 1.662 1.542.277 2.781.526 3.634.706a76.01 76.01 0 011.231.27l.063.014a.49.49 0 01.015.004h.005l.184-.779.183-.78h-.001l-.005-.001-.017-.004-.068-.016a80.808 80.808 0 00-1.26-.276c-.866-.182-2.122-.434-3.681-.714a146.606 146.606 0 00-12.322-1.681c-9.702-.893-21.688-.915-30.392 2.733l.619 1.478z"
		></path>
	</svg>
);

const MobilePage = () => {
	return (
		<div className="small-mobile-flag-out-wrap-index-box">
			<div className="main-wrapper">
				{/* logo box start */}
				<div className="logo-box">
					<figure className="img-box">{redpayLogo}</figure>
				</div>
				{/* logo box end */}
				{/* mobile img start */}
				<div className="mobile-box">
					<figure className="img-box">{mobileImg}</figure>
				</div>
				{/* mobile img end */}
				{/* big text start */}
				<div className="big-text-box">
					<p className="text">
						Kindly open this page on a desktop for the best of experience
					</p>
				</div>
				{/* big text end */}
			</div>
		</div>
	);
};

export default MobilePage;
